module.exports = __webpack_public_path__ + "static/img/35.2f73171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/35.png
// module id = 8gH2
// module chunks = 1